import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Safely converts string or number to number
 * @param value - String or number value to convert
 * @param fallback - Fallback value if conversion fails (default: 0)
 * @returns Converted number value
 */
export function toNumber(value: string | number | undefined | null, fallback = 0): number {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'number') return value;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? fallback : parsed;
}

/**
 * Format a number for display (handles null/undefined, optional decimals/locale).
 */
export function formatNumber(
  value: number | string | undefined | null,
  options?: { decimals?: number; locale?: string },
): string {
  const num = toNumber(value);
  const { decimals, locale = 'en-US' } = options ?? {};
  if (decimals !== undefined) {
    return num.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  return num.toLocaleString(locale);
}

// Re-export utility functions
export { extractErrorMessage } from "./utils/error"
export { formatDateTime, formatDate } from "./utils/date"
// Note: fetchWithAuth was removed. Use `axiosClientAPI` from '@/lib/axios' directly when needed.